import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'rgpd_consent';

/**
 * Banner RGPD bottom-fixed. Aparece solo si el usuario no ha dado
 * consentimiento todavia. Cookies tecnicas necesarias (auth + session)
 * NO requieren consentimiento legal, pero mostramos el banner por
 * transparencia y para ofrecer link a politica de privacidad.
 *
 * Sin tracking analytics ni pixeles publicitarios · si en el futuro se
 * anaden, este banner debe gestionar opt-in granular.
 */
export default function CookieBanner(): JSX.Element | null {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== 'accepted') {
        setVisible(true);
      }
    } catch {
      // localStorage podria estar deshabilitado · mostramos banner
      // por seguridad (mejor mostrar que ocultar incumpliendo).
      setVisible(true);
    }
  }, []);

  function accept(): void {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // ignore
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-canvas/95 px-4 py-4 backdrop-blur-md sm:px-6"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-ink/70 sm:text-sm">
          Usamos cookies técnicas necesarias para el funcionamiento (auth + sesión).
          No usamos cookies analytics ni tracking publicitario.{' '}
          <Link
            to="/privacidad"
            className="underline decoration-ink/40 underline-offset-2 hover:text-ink"
          >
            Más info
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={accept}
            className="btn-primary px-4 py-2 text-xs"
            aria-label="Aceptar el uso de cookies tecnicas"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
